/* ============================================================
   VITAE - Moteur du tiroir panier
   Fichier : assets/vitae-cart.js

   Charge depuis le HEADER, donc actif sur TOUTES les pages.

   Expose :
     window.vitCartOpen()
     window.vitCartClose()
     window.vitCartRefresh()

   Optimisations :
   - IDs / comportement commercial conserves
   - erreurs HTTP Shopify correctement gerees
   - panier courant garde en memoire
   - suppression du GET /cart.js avant chaque + / - / retirer
     lorsque le panier courant est deja connu
   - Intl.NumberFormat reutilise
   - URL images Shopify optimisee proprement avec ?width=
   - decoding async sur images generees
   - gestion focus ouverture / fermeture
   - aria-busy pendant les mutations
   - garde contre les doubles requetes
   ============================================================ */

(function () {
  'use strict';


  if (window.__vitCartInit) {
    return;
  }

  window.__vitCartInit = true;


  /* =========================================================
     IDS REELS
     ========================================================= */

  var ID_PACK =
    58640337174902;

  var ID_CARNET =
    58695970914678;

  var ID_PILULIER =
    58695970980214;

  var ID_PROTECTION =
    58695971242358;


  /* (2026-10-27, the owner: « it should be already ticked on ALL pdp pages. from now and forever. ») the shopper's own
     « no protection » for this visit, the same key as the product pages' cart (sessionStorage; refused: this page only). */
  var protOffMem = false;

  function protOff(set) {
    if (set === true || set === false) {
      protOffMem = set;
    }
    try {
      if (set === true) sessionStorage.setItem('vitCartProtectionOff', '1');
      else if (set === false) sessionStorage.removeItem('vitCartProtectionOff');
      else return sessionStorage.getItem('vitCartProtectionOff') === '1' || protOffMem;
    } catch (e) { /* private mode */ }
    return protOffMem;
  }


  var GIFT_IDS = [
    ID_CARNET,
    ID_PILULIER
  ];


  var FREE_SHIP_CTS =
    0;


  var TIER_CARNET =
    2;

  var TIER_PILULIER =
    3;

  /* Étui Nomade : visuel cadeau du palier 3.
     Aucun variant ID Shopify n'a encore été fourni,
     donc il n'est pas ajouté comme ligne 0 € au panier. */
  var TIER_NOMAD =
    3;


  var GIFT_VALUE = {};

  GIFT_VALUE[ID_CARNET] =
    1999;

  GIFT_VALUE[ID_PILULIER] =
    2499;


  /* =========================================================
     ELEMENTS
     ========================================================= */

  var cartEl =
    document.getElementById('vitCart');


  if (!cartEl) {
    return;
  }


  var cartBody =
    document.getElementById(
      'vitCartBody'
    );

  var cartFoot =
    document.getElementById(
      'vitCartFoot'
    );

  var cartHead =
    document.getElementById(
      'vitCartCountHead'
    );

  var cartTot =
    document.getElementById(
      'vitCartTotal'
    );

  var shipTxt =
    document.getElementById(
      'vitCartShipTxt'
    );

  var shipFill =
    document.getElementById(
      'vitCartShipFill'
    );

  var protTog =
    document.getElementById(
      'vitProtectToggle'
    );

  var closeBtn =
    document.getElementById(
      'vitCartClose'
    );

  var overlay =
    document.getElementById(
      'vitCartOverlay'
    );

  var checkout =
    document.getElementById(
      'vitCartCheckout'
    );


  var giftEls = {};


  [
    'ship',
    'carnet',
    'pilulier',
    'nomad'
  ].forEach(function (key) {

    giftEls[key] =
      cartEl.querySelector(
        '[data-gift="' +
        key +
        '"]'
      );
  });


  /*
    Position fixed peut etre casse
    par un ancetre transforme.
  */

  if (
    cartEl.parentNode !==
    document.body
  ) {
    document.body.appendChild(
      cartEl
    );
  }


  /* =========================================================
     ETAT
     ========================================================= */

  var busy = false;

  var currentCart = null;

  var lastFocusedElement = null;

  var CUR = 'EUR';

  var moneyFormatter = null;

  var moneyFormatterCurrency = null;


  /* =========================================================
     OUTILS
     ========================================================= */

  function getMoneyFormatter(currency) {

    if (
      moneyFormatter &&
      moneyFormatterCurrency === currency
    ) {
      return moneyFormatter;
    }


    try {

      moneyFormatter =
        new Intl.NumberFormat(
          'fr-FR',
          {
            style: 'currency',
            currency: currency
          }
        );

      moneyFormatterCurrency =
        currency;

      return moneyFormatter;

    } catch (e) {

      moneyFormatter = null;

      moneyFormatterCurrency = null;

      return null;
    }
  }


  function money(cents) {

    var value =
      Number(cents) / 100;


    if (!isFinite(value)) {
      value = 0;
    }


    var formatter =
      getMoneyFormatter(CUR);


    if (formatter) {
      return formatter.format(value);
    }


    return (
      value
        .toFixed(2)
        .replace('.', ',') +
      '\u00A0€'
    );
  }


  function requestJson(
    url,
    options
  ) {

    return fetch(
      url,
      options
    ).then(function (response) {

      if (!response.ok) {

        return response
          .text()
          .then(function (text) {

            throw new Error(
              text ||
              'Erreur Shopify ' +
              response.status
            );
          });
      }


      return response.json();
    });
  }


  function jsonPost(
    url,
    payload
  ) {

    return requestJson(
      url,
      {
        method: 'POST',

        credentials:
          'same-origin',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body:
          JSON.stringify(payload)
      }
    );
  }


  function getCart() {

    return requestJson(
      '/cart.js',
      {
        method: 'GET',

        credentials:
          'same-origin',

        cache:
          'no-store',

        headers: {
          'Accept':
            'application/json'
        }
      }
    );
  }


  function esc(value) {

    return String(value)
      .replace(
        /[&<>"']/g,
        function (character) {

          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          }[character];
        }
      );
  }


  function shopifyImage(
    url,
    width
  ) {

    if (!url) {
      return '';
    }


    try {

      var imageUrl =
        new URL(
          url,
          window.location.origin
        );


      imageUrl.searchParams.set(
        'width',
        String(width)
      );


      return imageUrl.toString();

    } catch (e) {

      var separator =
        url.indexOf('?') === -1
          ? '?'
          : '&';


      return (
        url +
        separator +
        'width=' +
        width
      );
    }
  }


  function emitCart(cart) {

    document.dispatchEvent(
      new CustomEvent(
        'vit:cart:updated',
        {
          detail: cart
        }
      )
    );
  }


  function setBusy(value) {

    busy = value;


    cartEl.classList.toggle(
      'is-busy',
      value
    );


    cartEl.setAttribute(
      'aria-busy',
      value ? 'true' : 'false'
    );


    if (checkout) {
      checkout.disabled = value;
    }
  }


  /* =========================================================
     OUVERTURE / FERMETURE
     ========================================================= */

  function openCart() {

    if (
      !cartEl.classList.contains(
        'is-open'
      )
    ) {

      lastFocusedElement =
        document.activeElement;
    }


    cartEl.classList.add(
      'is-open'
    );


    cartEl.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'vit-cart-open'
    );


    if (closeBtn) {

      window.requestAnimationFrame(
        function () {

          closeBtn.focus({
            preventScroll: true
          });
        }
      );
    }


    refresh();
  }


  function closeCart() {

    cartEl.classList.remove(
      'is-open'
    );


    cartEl.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'vit-cart-open'
    );


    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        'function'
    ) {

      try {

        lastFocusedElement.focus({
          preventScroll: true
        });

      } catch (e) {

        lastFocusedElement.focus();
      }
    }


    lastFocusedElement = null;
  }


  window.vitCartOpen =
    openCart;

  window.vitCartClose =
    closeCart;

  window.vitCartRefresh =
    function () {
      return refresh();
    };


  if (closeBtn) {

    closeBtn.addEventListener(
      'click',
      closeCart
    );
  }


  if (overlay) {

    overlay.addEventListener(
      'click',
      closeCart
    );
  }


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        cartEl.classList.contains(
          'is-open'
        )
      ) {

        closeCart();

        return;
      }


      /*
        Petit focus trap uniquement
        quand le drawer est ouvert.
      */

      if (
        event.key !== 'Tab' ||
        !cartEl.classList.contains(
          'is-open'
        )
      ) {
        return;
      }


      var focusable =
        cartEl.querySelectorAll(
          'button:not([disabled]),' +
          'a[href],' +
          'input:not([disabled]),' +
          '[tabindex]:not([tabindex="-1"])'
        );


      if (!focusable.length) {
        return;
      }


      var first =
        focusable[0];

      var last =
        focusable[
          focusable.length - 1
        ];


      if (
        event.shiftKey &&
        document.activeElement === first
      ) {

        event.preventDefault();

        last.focus();
      }


      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {

        event.preventDefault();

        first.focus();
      }
    }
  );


  /* =========================================================
     LECTURE DU PANIER
     ========================================================= */

  function packCount(cart) {

    var count = 0;


    cart.items.forEach(
      function (item) {

        if (
          item.variant_id === ID_PACK
        ) {

          count += item.quantity;
        }
      }
    );


    return count;
  }


  function qtyOf(
    cart,
    id
  ) {

    var count = 0;


    cart.items.forEach(
      function (item) {

        if (
          item.variant_id === id
        ) {

          count += item.quantity;
        }
      }
    );


    return count;
  }


  /* =========================================================
     CADEAUX AUTOMATIQUES
     ========================================================= */

  function reconcile(cart) {

    var packs =
      packCount(cart);


    var want = {};


    want[ID_CARNET] =
      packs >= TIER_CARNET
        ? 1
        : 0;


    want[ID_PILULIER] =
      packs >= TIER_PILULIER
        ? 1
        : 0;


    var updates = {};

    var needUpdate = false;


    GIFT_IDS.forEach(
      function (id) {

        if (
          qtyOf(cart, id) !==
          want[id]
        ) {

          updates[id] =
            want[id];

          needUpdate = true;
        }
      }
    );


    /*
      (2026-10-27, the owner: « ALL ») Protection Colis : cochee par
      defaut des que le panier contient un article payant (tous les
      produits), sauf si le client l'a retiree pendant la visite ;
      retiree d'un panier sans article payant. Une seule unite.
    */

    var paidN = 0;

    cart.items.forEach(function (item) {
      if (
        item.quantity > 0 &&
        item.variant_id !== ID_PROTECTION &&
        GIFT_IDS.indexOf(item.variant_id) < 0 &&
        !(item.price === 0 && !(Number(item.original_price) > 0))
      ) {
        paidN++;
      }
    });

    if (!paidN) {
      protOff(false);
    }

    var wantProt = paidN && !protOff() ? 1 : 0;

    if (qtyOf(cart, ID_PROTECTION) !== wantProt) {

      updates[ID_PROTECTION] = wantProt;

      needUpdate = true;
    }


    if (!needUpdate) {

      return Promise.resolve(
        cart
      );
    }


    return jsonPost(
      '/cart/update.js',
      {
        updates: updates
      }
    );
  }


  /* =========================================================
     RENDU LIGNES
     ========================================================= */

  function lineHtml(item) {

    var isGift =
      item.variant_id === ID_CARNET ||
      item.variant_id === ID_PILULIER;


    var isProtection =
      item.variant_id ===
      ID_PROTECTION;


    var image =
      item.image
        ? shopifyImage(
            item.image,
            160
          )
        : '';


    var name =
      esc(
        item.product_title ||
        ''
      );


    if (isGift) {

      var giftValue =
        GIFT_VALUE[
          item.variant_id
        ] || 0;


      return (
        '<div class="vit-cart__line vit-cart__line--gift">' +

          '<span class="vit-cart__line-media">' +

            (
              image
                ? '<img src="' +
                  image +
                  '" alt="" loading="lazy" decoding="async">'
                : ''
            ) +

          '</span>' +


          '<span class="vit-cart__line-info">' +

            '<span class="vit-cart__gift-tag">' +
              'OFFERT' +
            '</span>' +

            '<p class="vit-cart__line-name">' +
              name +
            '</p>' +

          '</span>' +


          '<span class="vit-cart__line-right">' +

            (
              giftValue
                ? '<span class="vit-cart__line-was">' +
                  money(giftValue) +
                  '</span>'
                : ''
            ) +

            '<span class="vit-cart__line-price vit-cart__line-price--free">' +
              money(0) +
            '</span>' +

          '</span>' +

        '</div>'
      );
    }


    var qtyBlock;


    if (isProtection) {

      qtyBlock =
        '<p class="vit-cart__line-sub">' +
          'Option' +
        '</p>';

    } else {

      qtyBlock =
        '<span class="vit-cart__qty">' +

          '<button type="button" data-act="minus" data-id="' +
            item.variant_id +
            '" aria-label="Réduire la quantité">' +
            '&minus;' +
          '</button>' +

          '<span>' +
            item.quantity +
          '</span>' +

          '<button type="button" data-act="plus" data-id="' +
            item.variant_id +
            '" aria-label="Augmenter la quantité">' +
            '+' +
          '</button>' +

        '</span>';
    }


    var was = '';


    if (
      item.original_line_price &&
      item.original_line_price >
        item.final_line_price
    ) {

      was =
        '<span class="vit-cart__line-was">' +
          money(
            item.original_line_price
          ) +
        '</span>';
    }


    return (
      '<div class="vit-cart__line">' +

        '<span class="vit-cart__line-media">' +

          (
            image
              ? '<img src="' +
                image +
                '" alt="" loading="lazy" decoding="async">'
              : ''
          ) +

        '</span>' +


        '<span class="vit-cart__line-info">' +

          '<p class="vit-cart__line-name">' +
            name +
          '</p>' +

          qtyBlock +

        '</span>' +


        '<span class="vit-cart__line-right">' +

          was +

          '<span class="vit-cart__line-price">' +
            money(
              item.final_line_price
            ) +
          '</span>' +

          '<button type="button" class="vit-cart__line-remove" data-act="remove" data-id="' +
            item.variant_id +
            '" aria-label="Retirer ' +
            name +
            ' du panier">' +
            'Retirer' +
          '</button>' +

        '</span>' +

      '</div>'
    );
  }


  /* =========================================================
     RENDU PANIER
     ========================================================= */

  function render(cart) {

    currentCart = cart;


    CUR =
      cart.currency ||
      'EUR';


    var packs =
      packCount(cart);


    var visible =
      cart.items.filter(
        function (item) {

          return item.quantity > 0;
        }
      );


    if (cartHead) {

      cartHead.textContent =
        '(' +
        cart.item_count +
        ')';
    }


    if (!visible.length) {

      cartEl.classList.add(
        'is-empty'
      );


      if (cartBody) {

        cartBody.innerHTML =
          '<div class="vit-cart__empty-cro">' +

            '<span class="vit-cart__empty-eyebrow">' +
              'VOTRE PANIER EST VIDE' +
            '</span>' +

            '<h2 class="vit-cart__empty-title">' +
              'Votre cure commence ici' +
            '</h2>' +

            '<p class="vit-cart__empty-subtitle">' +
              'Débloquez jusqu’à <strong>4 avantages offerts</strong>' +
            '</p>' +

            '<div class="vit-cart__empty-gifts" role="list" aria-label="Avantages offerts selon le nombre de packs">' +

              '<div class="vit-cart__empty-gift" role="listitem">' +
                '<span class="vit-cart__empty-gift-media vit-cart__empty-gift-media--ship">' +
                  '<img src="https://cdn.shopify.com/s/files/1/0949/1706/7126/files/Sub_Products_Upsells_2.png?v=1789208809&width=140" alt="Livraison offerte" width="140" height="64" loading="lazy" decoding="async">' +
                '</span>' +
                '<b>Livraison</b>' +
                '<small>DÈS 1 PACK</small>' +
              '</div>' +

              '<span class="vit-cart__empty-plus" aria-hidden="true">+</span>' +

              '<div class="vit-cart__empty-gift" role="listitem">' +
                '<span class="vit-cart__empty-gift-media">' +
                  '<img src="https://cdn.shopify.com/s/files/1/0949/1706/7126/files/Sub_Products_Upsells_4.png?v=1789209128&width=140" alt="Carnet Rouge offert" width="98" height="140" loading="lazy" decoding="async">' +
                '</span>' +
                '<b>Carnet Rouge</b>' +
                '<small>DÈS 2 PACKS</small>' +
              '</div>' +

              '<span class="vit-cart__empty-plus" aria-hidden="true">+</span>' +

              '<div class="vit-cart__empty-gift" role="listitem">' +
                '<span class="vit-cart__empty-gift-media">' +
                  '<img src="https://cdn.shopify.com/s/files/1/0949/1706/7126/files/Untitled_design_18.png?v=1788895248&width=140" alt="Pilulier bambou rose offert" width="140" height="140" loading="lazy" decoding="async">' +
                '</span>' +
                '<b>Pilulier</b>' +
                '<small>DÈS 3 PACKS</small>' +
              '</div>' +

              '<span class="vit-cart__empty-plus" aria-hidden="true">+</span>' +

              '<div class="vit-cart__empty-gift" role="listitem">' +
                '<span class="vit-cart__empty-gift-media">' +
                  '<img src="https://cdn.shopify.com/s/files/1/0949/1706/7126/files/Sub_Products_Upsells_5.png?v=1789568094&width=140" alt="Étui Nomade offert" width="140" height="140" loading="lazy" decoding="async">' +
                '</span>' +
                '<b>Étui Nomade</b>' +
                '<small>DÈS 3 PACKS</small>' +
              '</div>' +

            '</div>' +

            '<div class="vit-cart__empty-unlock">' +
              '<span>DÈS 3 PACKS</span>' +
              '<b>TOUT EST DÉBLOQUÉ</b>' +
            '</div>' +

            '<button type="button" class="vit-cart__empty-cta" data-empty-cta>' +
              'CHOISIR MA CURE' +
            '</button>' +

            '<p class="vit-cart__empty-secure">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-2.8 8-7 10-4.2-2-7-5.4-7-10V6l7-3z"/><polyline points="9 12 11 14 15 10"/></svg>' +
              'Paiement sécurisé' +
            '</p>' +

          '</div>';
      }


      if (cartFoot) {
        cartFoot.hidden = true;
      }


      if (shipFill) {
        shipFill.style.width = '100%';
      }


      if (shipTxt) {

        shipTxt.innerHTML =
          '<b>Livraison offerte sur toutes les commandes</b>';
      }


      if (cartTot) {
        cartTot.textContent =
          money(0);
      }


      return cart;
    }


    cartEl.classList.remove(
      'is-empty'
    );


    /*
      Pack d'abord,
      protection ensuite,
      cadeaux en dernier.
    */

    function order(item) {

      if (
        item.variant_id ===
          ID_CARNET ||
        item.variant_id ===
          ID_PILULIER
      ) {
        return 2;
      }


      if (
        item.variant_id ===
        ID_PROTECTION
      ) {
        return 1;
      }


      return 0;
    }


    visible.sort(
      function (a, b) {

        return (
          order(a) -
          order(b)
        );
      }
    );


    if (cartBody) {

      cartBody.innerHTML =
        visible
          .map(lineHtml)
          .join('');
    }


    if (cartFoot) {
      cartFoot.hidden = false;
    }


    /* Livraison offerte */

    var total =
      cart.total_price;


    var percentage =
      Math.min(
        100,
        Math.round(
          total /
          FREE_SHIP_CTS *
          100
        )
      );


    if (shipFill) {

      shipFill.style.width =
        percentage + '%';
    }


    if (shipTxt) {

      if (
        total >=
        FREE_SHIP_CTS
      ) {

        shipTxt.innerHTML =
          '<b>Livraison offerte sur toutes les commandes</b>';

      } else {

        shipTxt.innerHTML =
          'Plus que <b>' +
          money(
            FREE_SHIP_CTS -
            total
          ) +
          '</b> pour la livraison offerte';
      }
    }


    /* Cadeaux */

    if (giftEls.ship) {

      giftEls.ship.classList.toggle(
        'is-locked',
        total < FREE_SHIP_CTS
      );
    }


    if (giftEls.carnet) {

      giftEls.carnet.classList.toggle(
        'is-locked',
        packs < TIER_CARNET
      );
    }


    if (giftEls.pilulier) {

      giftEls.pilulier.classList.toggle(
        'is-locked',
        packs < TIER_PILULIER
      );
    }


    if (giftEls.nomad) {

      giftEls.nomad.classList.toggle(
        'is-locked',
        packs < TIER_NOMAD
      );
    }


    /* Protection */

    if (protTog) {

      protTog.checked =
        qtyOf(
          cart,
          ID_PROTECTION
        ) > 0;
    }


    if (cartTot) {

      cartTot.textContent =
        money(total);
    }


    return cart;
  }


  /* =========================================================
     REFRESH
     ========================================================= */

  function refresh() {

    return getCart()

      .then(reconcile)

      .then(function (cart) {

        render(cart);

        emitCart(cart);

        return cart;
      })

      .catch(function () {

        cartEl.classList.remove(
          'is-empty'
        );

        if (cartBody) {

          cartBody.innerHTML =
            '<div class="vit-cart__empty">' +
              'Impossible de charger le panier.' +
            '</div>';
        }


        return null;
      });
  }


  /* =========================================================
     CHANGEMENT QUANTITE / SUPPRESSION
     ========================================================= */

  if (cartBody) {

    cartBody.addEventListener(
      'click',
      function (event) {

        var target =
          event.target;


        var emptyCta =
          target &&
          target.closest
            ? target.closest(
                '[data-empty-cta]'
              )
            : null;


        if (emptyCta) {

          var buyBox =
            document.getElementById(
              'vitBuyBox'
            );


          if (buyBox) {

            closeCart();

            window.setTimeout(
              function () {

                try {
                  buyBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  });
                } catch (e) {
                  buyBox.scrollIntoView();
                }
              },
              80
            );

          } else {

            window.location.href =
              '/products/extrait-dail-vieilli-24-mois-100-inodore#vitBuyBox';
          }

          return;
        }


        var button =
          target &&
          target.closest
            ? target.closest(
                '[data-act]'
              )
            : null;


        if (
          !button ||
          busy
        ) {
          return;
        }


        var id =
          parseInt(
            button.getAttribute(
              'data-id'
            ),
            10
          );


        if (!id) {
          return;
        }


        var action =
          button.getAttribute(
            'data-act'
          );


        setBusy(true);


        /*
          Le panier vient normalement d'être
          rendu, donc inutile de refaire
          /cart.js avant chaque clic.
        */

        var cartPromise =
          currentCart
            ? Promise.resolve(
                currentCart
              )
            : getCart();


        cartPromise

          .then(function (cart) {

            var current =
              qtyOf(
                cart,
                id
              );


            var next;


            if (action === 'plus') {

              next =
                current + 1;

            } else if (
              action === 'minus'
            ) {

              next =
                current - 1;

            } else {

              next = 0;
            }


            if (next < 0) {
              next = 0;
            }


            var updates = {};

            updates[id] =
              next;


            return jsonPost(
              '/cart/update.js',
              {
                updates: updates
              }
            );
          })

          .then(reconcile)

          .then(function (cart) {

            render(cart);

            emitCart(cart);

            setBusy(false);
          })

          .catch(function () {

            setBusy(false);

            refresh();
          });
      }
    );
  }


  /* =========================================================
     PROTECTION COLIS
     ========================================================= */

  if (protTog) {

    protTog.addEventListener(
      'change',
      function () {

        if (busy) {

          protTog.checked =
            !protTog.checked;

          return;
        }


        var enabled =
          protTog.checked;

        protOff(!enabled);


        setBusy(true);


        var updates = {};

        updates[ID_PROTECTION] =
          enabled ? 1 : 0;


        jsonPost(
          '/cart/update.js',
          {
            updates: updates
          }
        )

          .then(reconcile)

          .then(function (cart) {

            render(cart);

            emitCart(cart);

            setBusy(false);
          })

          .catch(function () {

            setBusy(false);

            refresh();
          });
      }
    );
  }


  /* =========================================================
     CHECKOUT
     ========================================================= */

  if (checkout) {

    checkout.addEventListener(
      'click',
      function () {

        if (busy) return;

        window.vtGoCheckout();
      }
    );
  }


  /* =========================================================
     INIT

     Aligne les cadeaux au chargement sans ouvrir le drawer.
     ========================================================= */

  getCart()

    .then(function (cart) {

      CUR =
        cart.currency ||
        'EUR';


      currentCart = cart;


      if (
        cart.item_count > 0
      ) {

        return reconcile(cart)
          .then(function (
            reconciledCart
          ) {

            currentCart =
              reconciledCart;

            return reconciledCart;
          });
      }


      return cart;
    })

    .catch(function () {});

})();